import React, { useEffect, useContext, useState, useRef } from 'react'
import {
  Box,
  Button,
  TextField,
  InputAdornment,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';

import folderIcon from "../../../images/folderIcon.svg"
import rectBlackCheckWhite from "../../../images/rectBlackCheckWhite.svg"

import UserAdminClientContext from "../../../contexts/UserAdminClientContext"
import LanguageContext from "../../../contexts/LanguageContext"

import MyModal from "../MyModal"


const SelectEcoleMenuMobile = ({  }) => {

  const [selectEcoleDrawer, setSelectEcoleDrawer] = useState(false)
  const [searchEcole, setSearchEcole] = useState("")
  const [filteredEcoles, setFilteredEcoles] = useState([])

  const {
    actPage,
    actEcoleID,
    actEcole,
    userLoaded,
    ecoles,
    updateActEcole,
  } = useContext(UserAdminClientContext)

  const {
    actLanguage,
    languageValues,
  } = useContext(LanguageContext)

  useEffect(() => {
    if (selectEcoleDrawer === false) {
      setSearchEcole("")
    }
  }, [selectEcoleDrawer])

  useEffect(() => {
    if (searchEcole?.length === 0) {
      setFilteredEcoles(ecoles)
    } else {
      let newEcoles = ecoles?.filter((el) => {
        let indexOf = el?.name?.trim()?.toLowerCase()?.indexOf(searchEcole?.trim()?.toLowerCase())
        if (indexOf >= 0) { return true } else { return false }
      })
      setFilteredEcoles(newEcoles)
    }
  }, [ecoles, searchEcole])


  return (
    <Box sx={{
      width:"100%",
      height:"50px",
      borderTop:"1px solid black",
      borderBottom:"1px solid black",
      background:"#EFEFEF",
      position:"relative",
      color:"text.secondary",
      userSelect:"none",
      fontSize:"15px",
    }}>
      {ecoles?.length > 0 &&
        <>
          <Box
            onClick={() => { setSelectEcoleDrawer(true) }}
            sx={{
              display:"flex",
              height:"100%",
              alignItems:"center",
              padding:"15px",
              overflow:"hidden",
              cursor:"pointer",
              gap:"8px",
              justifyContent:"space-between",
            }}
          >
            <Box sx={{
              display:"flex",
              alignItems:"center",
              overflow:"hidden",
              cursor:"pointer",
              gap:"8px",
            }}>
              <img src={folderIcon} style={{width:"20px"}}/>
              <span style={{
                textTransform:"capitalize",
                whiteSpace:"nowrap",
                overflow:"hidden",
                textOverflow:"ellipsis",
              }}>{actEcole?.name}</span>
            </Box>
            <KeyboardArrowDownIcon sx={{
              width:"20px",
              transform:selectEcoleDrawer === true && "rotate(180deg)",
            }}/>
          </Box>

          <MyModal
            isOpen={selectEcoleDrawer}
            maxWidth="xs"
            onClose={() => {
              setSelectEcoleDrawer(false)
            }}
            title={languageValues?.adminDashboard?.drawerSearchEcoleMobile[actLanguage]}
          >
            <Box sx={{
              display:"flex",
              flexDirection:"column",
              flex:1,
              justifyContent:"space-between",
              gap:"10px",
            }}>
              <Box sx={{
                display:"flex",
                flexDirection:"column",
              }}>
                <TextField
                  fullWidth
                  name="search"
                  type="text"
                  value={searchEcole}
                  variant="standard"
                  placeholder={languageValues?.search[actLanguage]}
                  onChange={(e) => {
                    setSearchEcole(e.target.value);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInputBase-root" : {
                      height: "50px",
                      padding: "15px",
                    },
                    "& .MuiInputBase-input" : {
                      padding: "0px",
                    },
                  }}
                />
                <Box sx={{

                }}>
                  {filteredEcoles?.map((ecole, index) => {
                    let active = false
                    if (ecole?.ecoleID === actEcoleID) {
                      active = true
                    }
                    return (
                      <Box
                        key={index}
                        onClick={() => { updateActEcole(ecole?.ecoleID, "home"); setSelectEcoleDrawer(false) }}
                        sx={{
                          height:"50px",
                          padding:"15px",
                          display:"flex",
                          alignItems:"center",
                          overflow:"hidden",
                          gap:"8px",
                          justifyContent:"space-between",
                          backgroundColor:active && "background.grey",
                          cursor:"pointer",
                        }}
                      >
                        <Box sx={{
                          display:"flex",
                          alignItems:"center",
                          overflow:"hidden",
                          gap:"8px",
                        }}>
                          <img src={folderIcon} style={{width:"20px"}}/>
                          <span style={{
                            textTransform:"capitalize",
                            whiteSpace:"nowrap",
                            overflow:"hidden",
                            textOverflow:"ellipsis",
                          }}>{ecole?.name}</span>
                        </Box>
                        {active &&
                          <img src={rectBlackCheckWhite} style={{width:"20px",height:"20px",minWidth:"20px",}} />
                        }
                      </Box>
                    )
                  })}
                </Box>
              </Box>
              <Box sx={{
                paddingTop:["0px", "30px"],
                display:"flex",
                gap:"20px",
              }}>
                <Button
                  fullWidth
                  disableRipple
                  size="large"
                  type="submit"
                  variant="standard"
                  onClick={() => {
                    setSelectEcoleDrawer(false)
                  }}
                  sx={{
                    justifyContent:"flex-start",
                    color:"text.secondary",
                    textDecoration:"underline",
                    "&:hover" : {
                      background:"transparent",
                      color:"rgba(0,0,0,0.75)",
                      textDecoration:"underline",
                    }
                  }}
                >
                  {languageValues?.close[actLanguage]}
                </Button>
                <Button
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  onClick={() => {
                    setSelectEcoleDrawer(false)
                  }}
                >
                  {languageValues?.continue[actLanguage]}
                </Button>
              </Box>
            </Box>
          </MyModal>
        </>
      }
    </Box>
  )
}


export default SelectEcoleMenuMobile
